<template>
  <v-container>
    <!-- color analysis-->

    <v-card flat>
      <v-card-title>IN COLOR ANALYSIS</v-card-title>
      <v-row>
        <v-col v-for="v in vecs" :key="v">
          <v-switch v-model="stripSwitches" :label="v" :value="v"></v-switch>
        </v-col>
      </v-row>
      <v-progress-linear
        v-if="isLoading"
        :indeterminate="true"
        color="accent"
        :active="isLoading"
        height="2"
      ></v-progress-linear>
      <content-detail
        :strip="masterStrip"
        :items="reasons"
        :compressed="false"
        :row-type="rowType"
        :item-type="rowType"
        score
        :card-title="contentHeading"
        merge-button
        @merge="merge"
        :player-instance="disambigTypes"
        :merge-into="thisFilm"
      ></content-detail>
    </v-card>
  </v-container>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import { vxMaps } from '@/js/vxstore'
import { StripSearcher } from '../gql'
import { getIcon } from '@/js/store'
import Contentdetail from '@/components/Contentdetail'
import { mergeFilm } from '@/gql'
import { showToaster, mutate } from '@/js/apollo'

export default {
  components: {
    'content-detail': Contentdetail,
  },
  props: {
    reason: Object,
    editing: String,
    editable: Boolean,
    similarsection: Boolean,
    dirty: Boolean,
    master: Object,
  },
  methods: {
    merge(pack) {
      const { match: sourceName, matchID: sourceID } = pack
      if (sourceID === this.filmID) {
        showToaster({
          header: 'error',
          type: 'error',
          message: 'something went wrong - cant merge a film with itself',
        })
      } else {
        this.$dialog
          .confirm(
            {
              title: `Merging ${sourceName}:${sourceID} into ${this.filmName}:${this.filmID}`,
              body: `Once merged, this will also remove film ${sourceName}:${sourceID} - are you sure ?`,
            },
            {
              okText: 'Merge',
              loader: true,
              cancelText: 'Cancel',
              animation: 'fade',
            },
          )
          .then((dialog) => {
            const variables = {
              id: sourceID,
              targetID: this.filmID,
            }

            return mutate({
              mutation: mergeFilm,
              variables,
            }).then((r) => {
              showToaster({
                header: 'Merge completed',
                type: 'success',
                message: 'The films have been successfully merged',
              })
              dialog.close()
              this.$emit('refreshfilm', this.film)
              return r
            })
          })
          .catch((err) => {
            if (err) {
              showToaster({
                header: 'Something went wrong',
                type: 'error',
                message: err,
                error: err,
              })
            } else {
              console.log(err, 'Clicked on cancel')
            }
          })
      }
    },
    refScore(match) {
      return this.referenceScore ? match.score / this.referenceScore : 0
    },
    isThisFilm(film) {
      return this.filmID === (film && film.id)
    },
    refreshFilm(film) {
      this.$emit('refreshfilm', film)
    },
    getStripUrl(master) {
      const u =
        master && master.StripArtifact && master.StripArtifact.SignedUrl.url
      return u
    },

    ...mapMutations(vxMaps.mutations),
  },
  data: () => ({
    masterDirty: false,
    rowType: 'film',
    contentHeading: 'Films with similar color strips',
    disambigTypes: 'a,b',
  }),
  computed: {
    isLoading() {
      return this.$apollo.loading
    },
    stripSwitches: {
      get() {
        return this.vecSelect
      },
      set(value) {
        return this.setVecSelect(value)
      },
    },
    shrinkSearch() {
      // the problem here is that strip searcher is master based,
      // whereas what we really need is a summarizatioin by film, since this this what gets merged
      // first remove all the masters with too low a confidence
      const matches = (this.stripMatches || []).filter(
        (f) => this.refScore(f) >= this.confidence,
      )
      if (!matches.length) return null

      const films = new Set(matches.map((f) => f.FilmMaster.Film.id))

      // now pick the best scoring master from each film
      const bests = Array.from(films).reduce((p, c) => {
        const best = matches
          .filter((f) => f.FilmMaster.Film.id === c)
          .reduce((p, c) => {
            return !p || c.score > p.score ? c : p
          }, null)
        p.push(best)
        return p
      }, [])

      // now we have a list of masters - only 1 per film - let's double check it actually contains the matched master
      // for debugging
      if (!bests.find((f) => f.FilmMaster.id === this.filmMasterID)) {
        console.log(
          '..didnt find current master',
          this.filmMasterID,
          bests,
          matches,
        )
      }

      // now we need to turn the whole things inside out
      const bestMap = new Map(bests.map((m) => [m.FilmMaster.Film.id, m]))
      const byFilm = Array.from(films).map((film) => {
        const match = bestMap.get(film)
        if (!match) {
          console.log('... bad thing ...didnt find match for film', film)
          return null
        } else {
          const Film = { ...match.FilmMaster.Film }
          const FilmMaster = { ...match.FilmMaster }
          delete FilmMaster.Film
          Film.FilmMasters = [FilmMaster]
          return {
            ...match,
            Film,
          }
        }
      })
      return byFilm
    },
    referenceScore() {
      return (this.colorSearchResult && this.colorSearchResult.maxScore) || 1
    },
    reasons() {
      const matches = this.vecSelect.length ? this.shrinkSearch : null
      return (
        matches &&
        matches.map((f) => {
          const stripReason = this.getStripUrl(f.FilmMaster)
          const film = f.FilmMaster.Film
          const itemReason = {
            ...f,
            matchType: 'film',
            matchID: film.id,
            match: film.filmName,
            filmID: film.id,
            stripReason,
          }

          const m = {
            itemID: this.filmID,
            itemName: this.filmName,
            itemType: 'film',
            itemReason,
            isThisFilm: this.isThisFilm(film),
            MatchReasons: [itemReason],
            score: this.refScore(f),
            colorName: this.isThisFilm(f) ? 'accent' : 'secondary',
          }
     
          return m
        })
      )
    },
    stripMatches() {
      // pick up all the matching filmmasters
      const stripMatches =
        this.colorSearchResult && this.colorSearchResult.StripMatches
      return stripMatches || null
    },
    masterStrip() {
      return this.getStripUrl(this.filmMaster)
    },
    colorSearchResult() {
      return this.StripSearcher
    },

    xs() {
      return this.$vuetify.breakpoint.xs
    },
    filmName() {
      return this.film && this.film.filmName
    },
    filmID() {
      return this.film && this.film.id
    },
    film() {
      return this.reason && this.reason.Film
    },
    thisFilm() {
      return this.film && {
        Film: this.film
      }
    },
    filmMaster() {
      return this.master
    },
    filmMasterID() {
      return this.filmMaster && this.filmMaster.id
    },

    errorIcon() {
      return getIcon('error')
    },
    ...mapState(vxMaps.state),
    ...mapGetters(vxMaps.getters),
  },
  apollo: {
    StripSearcher: {
      skip() {
        return !this.masterStrip || !this.vecSelect.length
      },
      query: StripSearcher,
      variables() {
        const vars = {
          filmMasterID: this.filmMasterID,
          vectorNames: [...this.vecSelect],
        }
        return vars
      },
    },
  },
}
</script>
